import { FC, memo } from 'react'
import type { Props } from '../types'

const ResetACtion: FC<Props> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12.764 2.76833C11.3514 1.40874 9.4729 0.660156 7.47319 0.660156C3.35227 0.660156 0 3.87958 0 7.83718C0 10.706 1.79662 13.3026 4.5134 14.4295L3.55682 16.6602L8.65589 14.6212L6.48368 9.83513L5.38403 12.399C3.18007 11.6479 1.97232 10.0296 1.97232 7.806C1.97232 4.56716 4.58508 2.03041 7.91987 2.03041C9.44959 2.03041 10.9167 2.56101 12.0498 3.52511L12.4601 3.87383L12.7264 3.41845C12.7442 3.38836 12.764 3.3591 12.7832 3.33011L13 2.99588L12.764 2.76833Z"
      fill="currentColor"
    />
  </svg>
)

export default memo(ResetACtion)
